"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUploadedFile = void 0;
var is_plain_object_1 = require("is-plain-object");
function isUploadedFile(file) {
    return (typeof file === 'object' &&
        (0, is_plain_object_1.isPlainObject)(file) &&
        typeof file.uuid === 'string' &&
        typeof file.version === 'number' &&
        typeof file.size === 'number' &&
        typeof file.mime_type === 'string' &&
        typeof file.filename === 'string' &&
        file.version > 0 &&
        file.uuid.length > 0 &&
        file.size > 0 &&
        file.mime_type.length > 0 &&
        file.filename.length > 0);
}
exports.isUploadedFile = isUploadedFile;
